import { reportUiFailure, shouldReport } from "../../report-failure.js";

const MALFORMED_REPORT_WINDOW_MS = 60_000;

// A turn field the daemon sent but this client cannot read: a contract break, reported at
// most once a minute per field. Callers report only a present value; absent is an older daemon.
export function reportMalformedFrame(field: "turnStatus" | "turnEnd", agentId?: string): void {
  if (!shouldReport(`agents.malformed_frame:${field}`, MALFORMED_REPORT_WINDOW_MS)) return;
  reportUiFailure(
    "agents.malformed_frame",
    `malformed ${field}`,
    { field, agentId },
    { code: "malformed_frame" },
  );
}
